import type { ComponentProps } from "react";
import { UserRound } from "lucide-react";
import { SectionCard } from "@/shared/components/ui/SectionCard";
import { ProfileFields } from "./ProfileFields";

export function ProfileSection(props: ComponentProps<typeof ProfileFields>) {
  return (
    <SectionCard title="Personal details" icon={<UserRound />} description="A little about you.">
      <div className="space-y-[18px]">
        <ProfileFields {...props} />
      </div>
    </SectionCard>
  );
}
